/** Dzisiejsza data lokalna jako YYYY-MM-DD (dzień dziecka, nie UTC). */
export function todayISO(now: Date = new Date()): string {
  const y = now.getFullYear();
  const m = String(now.getMonth() + 1).padStart(2, '0');
  const d = String(now.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

function parse(iso: string): number {
  const [y, m, d] = iso.split('-').map(Number);
  return Date.UTC(y ?? 1970, (m ?? 1) - 1, d ?? 1);
}

function format(ms: number): string {
  const dt = new Date(ms);
  const y = dt.getUTCFullYear();
  const m = String(dt.getUTCMonth() + 1).padStart(2, '0');
  const d = String(dt.getUTCDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

/** Dodaje dni do daty ISO — liczone w UTC, więc odporne na zmianę czasu letni/zimowy. */
export function addDays(iso: string, days: number): string {
  return format(parse(iso) + days * 86_400_000);
}

export function daysBetween(fromIso: string, toIso: string): number {
  return Math.round((parse(toIso) - parse(fromIso)) / 86_400_000);
}

/** Dzień tygodnia daty ISO: 0 = poniedziałek … 6 = niedziela (liczone w UTC, więc bez wpływu strefy czasowej). */
export function weekdayIndex(iso: string): number {
  return (new Date(parse(iso)).getUTCDay() + 6) % 7;
}
